import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../../utils/apolloClient';
import jwt_decode from 'jwt-decode';
import { environmentURLs } from '../../../components/common/CaptureEnvironment';
const allowdRoles=['47', '51', '56', '57', '59', '63', '66', '69', '75', '81', '82', '83', '84', '86', '89', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '100', '101', '102', '104', '105', '58', '106', '107', '108', '109', '110', '111', '112', '114', '116', '117'];

const initialState = {
  allLocations: [],
  allLocationsWithoutMergingCmfs: [],
  isFortellisTermsAndConditionsAccepted: null,
  fortellisTermsAndConditionsData: [],
  fortellisTermsAndConditionsUpdatedDate: null,
  isAuthenticated: false,
  authenticationToken: null,
  loginSuccess: null,
  isLoginPending: null,
  errorInGettingDealer: false,
  errorInGettingToken: false,
  loadStepper: false,
  isLoading: false,
  userEmail: '',
  userGuid: '',
  enterpriseId: '',
  temporaryTokenForManageSubscriptions: '',
  isTokenForManageSubscriptionsPending: false,
  loggingOut : false,
  connectCdkToken: null,
  entityIdNameMapping: {},
  entityIdAddressMapping: {},
  hasDAABAccess: false,
  isDAABAccessChecked: false,
  entityDetails: { organizationName :'',fortellisDefinedType:'', id: ''},
  errorInGettingOrgName: false,
  isDealerPurchaseDisabled: false,
  isBundlePricingEnabled: false,
};
sessionStorage.setItem('isLoginAttempted',false);

export const getLoginDetails = createAsyncThunk(
  'getLoginDetails',
  async ({ accessToken }) => {
    // Fetch the backend endpoint:
    let {data} = await client.authorizeRequest({
      method: 'POST',
      url: '/authorize',
      headers:{
        Authorization : `Bearer ${accessToken}`
      }
    });
    return {data};
  }
);

export const getToken = createAsyncThunk(
  'getToken',
  async ({ isTemporaryTokenForManageSubscriptions, code, accessToken }) => {
    let tokenResponse = await client.authorizeRequest({
      method: 'POST',
      url: '/authorize',
      data: {
        code
      },
      headers:{
        Authorization : `Bearer ${accessToken}`
      }
    });
    return {
      tokenResponse,
      isTemporaryTokenForManageSubscriptions
    };
  }
);
export const getEntityDetailsById = createAsyncThunk(
  'getEntityDetailsById',
  async ({id, token}) => {
    let response = await client.authorizeRequest({
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${environmentURLs.ORGANIZATION_URL}/organizations/${id}`
    });
    return response.data;
  }
);

export const loginDetailsSlice = createSlice({
  name: 'loginDetailsSlice',
  initialState,
  reducers: {
    logout: (state, action) => {
      state.isAuthenticated = false ;
      state.authenticationToken = null;
      state.loggingOut = true ;
      state.userGuid = '';
    },
    decodedToken: (state, action) => {
      state.decodedToken = jwt_decode(action.payload);
      //state.userEmail = action.payload.userEmail;
    },
    setEmail: (state, action) => {
      state.userEmail = action.payload;
    },
    setUserGuid: (state, action) => {
      state.userGuid = action.payload;
    },
    setLocationsAsPerApp: (state, action) => {
      let{unAuthTitleEnabled} = action.payload
      if(unAuthTitleEnabled && allowdRoles.indexOf(state.roleId)>=0){
        state.allLocations = [...state.canPurchaseEnabled, ...state.canPurchaseDisabled ];
        state.authorised = true;
      }else{
        state.allLocations = [...state.canPurchaseEnabled];
        state.authorised =  false;
      }
      state.allLocationsWithoutMergingCmfs = [...state.canPurchaseEnabled];
      state.locationsProcessingDone = true;
    },
    setAllLocationsAfterMergingCMFs: (state, action) => {
      state.allLocations = action.payload
    },
    setProcessingDone: (state, action) => {
      state.locationsProcessingDone = action.payload;
    },
    setConnectCdkToken: (state, action) => {
      state.connectCdkToken = action.payload;
    },
    setHasDAABAccess: (state, action) => {
      state.hasDAABAccess = action.payload;
      state.isDAABAccessChecked = true;
    },
    setHideDealerPurchase: (state, action) => {
      state.isDealerPurchaseDisabled = action.payload;
    },
    setBundlePricingEnabled: (state, { payload }) => {
      state.isBundlePricingEnabled = payload;
    },
  },
  extraReducers: {
    [getLoginDetails.fulfilled]: (state, action) => {
      const {
        canPurchaseEnabled,
        canPurchaseDisabled,
        roleId,
        role,
        access_token,
        fortellisEnterpriseEntityId,
        enterpriseId
      } = action.payload.data;
      state.allLocations = [ ...canPurchaseEnabled ];
      state.allLocationsWithoutMergingCmfs = [...canPurchaseEnabled]
      state.isFortellisTermsAndConditionsAccepted = true;
      state.loginSuccess = true;
      state.isLoginPending = false;
      state.roleId = roleId;
      state.canPurchaseDisabled = canPurchaseDisabled;
      state.canPurchaseEnabled = canPurchaseEnabled;
      state.role = role;
      sessionStorage.setItem('isLoginAttempted',true);
      let mapping = {};
      let addressMapping = {};
      canPurchaseEnabled.forEach(entity => {
        const address = entity?.addresses[0];
        addressMapping[entity.entityId] = `${address?.streetAddress}, ${address?.city}`;
        mapping[entity.entityId] = entity.partyName;
      });
      state.entityIdAddressMapping = addressMapping;
      state.entityIdNameMapping = mapping;

      state.authenticationToken = access_token;
      state.enterpriseId = enterpriseId;
      state.fortellisEnterpriseEntityId = fortellisEnterpriseEntityId;
      state.isAuthenticated = true;
      state.isLoading = false;
      state.errorInGettingDealer = null;
    },
    [getLoginDetails.pending]: (state, action) => {
      state.isLoginPending = true;
      state.isLoading = true;
      state.isAuthenticated = false;
      state.errorInGettingDealer = null;
    },
    [getLoginDetails.rejected]: (state, action) => {
      state.isAuthenticated = false;
      state.loginSuccess = false;
      state.isLoginPending = true;
      state.isLoading = false;
      state.errorInGettingDealer = action.error;
      sessionStorage.setItem('isLoginAttempted',true);
    },
     [getEntityDetailsById.fulfilled]: (state, action = {payload: {name: '', fortellisDefinedType: '', id: ''}}) => {
          state.entityDetails.organizationName = action.payload.name;
          state.entityDetails.fortellisDefinedType = action.payload.fortellisDefinedType;
          state.entityDetails.id = action.payload.id;
          state.errorInGettingOrgName = false;
        },
        [getEntityDetailsById.pending]: state => {
          state.entityDetails.organizationName = '';
          state.entityDetails.fortellisDefinedType = '';
          state.entityDetails.id = '';
          state.errorInGettingOrgName = false;
        },
        [getEntityDetailsById.rejected]: state => {
          state.entityDetails.organizationName = '';
          state.entityDetails.fortellisDefinedType= '';
          state.entityDetails.id = '';
          state.errorInGettingOrgName = true;
        },
  }
});

export const {
  logout,
  decodedToken,
  setEmail,
  setUserGuid,
  setLocationsAsPerApp,
  setAllLocationsAfterMergingCMFs,
  setProcessingDone,
  setConnectCdkToken,
  setHasDAABAccess,
  setHideDealerPurchase,
  setBundlePricingEnabled
} = loginDetailsSlice.actions;

export default loginDetailsSlice.reducer;
